<template>
  <div class="p-4">
    <div class="flex justify-between items-center mb-4">
      <div class="flex items-center space-x-2">
        <label for="searchColumn" class="font-semibold">Search By</label>
        <select
          v-model="searchColumn"
          id="searchColumn"
          class="p-2 border rounded-md"
        >
          <option value="ticket_number">Ticket #</option>
          <option value="customer_name">Customer Name</option>
          <option value="customer_email">Customer Email</option>
          <option value="contact_phone">Contact Phone</option>
          <option value="address">Address</option>
          <option
            v-if="selected == 'residential'"
            value="residential_products_selected"
          >
            Residential Products
          </option>
          <option
            v-if="selected == 'residential'"
            value="residential_reward_points"
          >
            Residential Reward Points
          </option>
          <option
            v-if="selected == 'commercial'"
            value="business_name"
          >
            Business Name
          </option>
          <option
            v-if="selected == 'commercial'"
            value="commercial_first_name"
          >
            Commercial First Name
          </option>
          <option
            v-if="selected == 'commercial'"
            value="commercial_last_name"
          >
            Commercial Last Name
          </option>
          <option
            v-if="selected == 'commercial'"
            value="commercial_products_selected"
          >
            Commercial Products
          </option>
          <option
            v-if="selected == 'commercial'"
            value="commercial_reward_points"
          >
            Commercial Reward Points
          </option>
        </select>

        <label for="searchTerm" class="font-semibold">Search Term</label>
        <input
          v-model="searchTerm"
          type="text"
          id="searchTerm"
          class="p-2 border rounded-md"
          placeholder="Search term"
        />

        <button
          @click="search()"
          class="px-3.5 py-[9px] bg-blue_primary rounded-lg shadow justify-center items-center gap-2 flex"
        >
          <div class="text-white text-base font-semibold leading-normal">
            Search
          </div>
        </button>
      </div>

      <div class="flex items-center space-x-2">
        <div class="flex flex-col space-y-2">
          <div class="flex items-center space-x-4">
            <div class="flex flex-col">
              <label for="startDate" class="font-semibold">Start Date</label>
              <input
                v-model="startDate"
                type="date"
                id="startDate"
                class="p-2 border rounded-md"
              />
            </div>
            <div class="flex flex-col">
              <label for="endDate" class="font-semibold">End Date</label>
              <input
                v-model="endDate"
                type="date"
                id="endDate"
                class="p-2 border rounded-md"
              />
            </div>
          </div>
        </div>

        <div class="flex flex-col space-y-2">
          <label for="statusFilter" class="font-semibold">Status</label>
          <select
            v-model="statusFilter"
            id="statusFilter"
            class="p-2 border rounded-md"
          >
            <option value="">All Statuses</option>
            <option value="Assigned to commercial account executive">
              Assigned to commercial account executive
            </option>
            <option value="Assigned to small business account executive">
              Assigned to small business account executive
            </option>
            <option value="1st Contact">1st Contact</option>
            <option value="2nd Contact">2nd Contact</option>
            <option value="Customer requested call back">
              Customer requested call back
            </option>
            <option value="Checking serviceability">
              Checking serviceability
            </option>
            <option value="Hold – awaiting Fiber">Hold – awaiting Fiber</option>
            <option value="Hold – awaiting DSL">Hold – awaiting DSL</option>
            <option value="Hold – Other">Hold – Other</option>
            <option value="Order placed">Order placed</option>
            <option value="Sale – points earned">Sale – points earned</option>
            <option value="No sale – duplicate lead">
              No sale – duplicate lead
            </option>
            <option value="No sale – not eligible referral">
              No sale – not eligible referral
            </option>
            <option value="No sale – not serviceable">
              No sale – not serviceable
            </option>
            <option value="Lost – customer declined">
              Lost – customer declined
            </option>
            <option value="Lost – customer did not respond">
              Lost – customer did not respond
            </option>
            <option value="Re-open Ticket">Re-open Ticket</option>
          </select>
        </div>
        <button
          @click="applyFilters()"
          class="px-3.5 py-[9px] bg-blue_primary rounded-lg shadow justify-center items-center gap-2 flex"
        >
          <div class="text-white text-base font-semibold leading-normal">
            Apply Filters
          </div>
        </button>
        <button
          @click="reset()"
          class="px-3.5 py-[9px] bg-blue_primary rounded-lg shadow justify-center items-center gap-2 flex"
        >
          <div class="text-white text-base font-semibold leading-normal">
            Reset
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watchEffect } from "vue";
import { useStore } from "vuex";

export default {
  setup() {
    const store = useStore();
    const searchColumn = ref("");
    const searchTerm = ref("");
    const startDate = ref("");
    const endDate = ref("");
    const statusFilter = ref("");
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    const selected = ref(
      sessionStorage.getItem("selectedButton") || "residential"
    );

    window.addEventListener("storage", () => {
      selected.value =
        sessionStorage.getItem("selectedButton") || "residential";
    });
    watchEffect(() => {
      const storedType = sessionStorage.getItem("selectedButton");
      if (storedType) {
        selected.value = storedType;
      }
    });

    async function applyFilters() {
      await store.commit("setLoading", true);
      await store.dispatch("fetchData", {
        submitter_email_contact: userData.email,
        page: 1,
        limit: 15,
        column: searchColumn.value,
        searchValue: searchTerm.value,
        startDate: startDate.value,
        endDate: endDate.value,
        status: statusFilter.value,
      });
      await store.commit("setLoading", false);
    }

    async function search() {
      await store.commit("setLoading", true);
      await store.dispatch("fetchData", {
        submitter_email_contact: userData.email,
        page: 1,
        limit: 15,
        column: searchColumn.value,
        searchValue: searchTerm.value,
      });
      await store.commit("setLoading", false);
      searchTerm.value = "";
    }

    async function reset() {
      await store.commit("setLoading", true);
      await store.dispatch("fetchData", {
        submitter_email_contact: userData.email,
        page: 1,
        limit: 15,
      });
      await store.commit("setLoading", false);
      searchTerm.value = "";
      endDate.value = "";
      startDate.value = "";
      searchColumn.value = "";
      statusFilter.value = "";
    }

    return {
      applyFilters,
      search,
      searchColumn,
      searchTerm,
      reset,
      startDate,
      endDate,
      statusFilter,
      selected,
    };
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
